import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface RecipientInfoProps {
  recipientName?: string
  email?: string
  phone?: string
  rootStyle?: stylex.StyleXStyles
}

export const RecipientInfo = ({ recipientName, email, phone, rootStyle }: RecipientInfoProps) => {
  const { t } = useTranslation()
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">{t('orderDetail.recipientInfo', { defaultValue: '收件人資訊' })}</Text>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.recipientName', { defaultValue: '收件人' })}</Text>
        <Text variant="body">{recipientName}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.recipientEmail', { defaultValue: 'Email' })}</Text>
        <Text variant="body">{email}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text variant="body" color={colors.grey600}>{t('orderDetail.recipientPhone', { defaultValue: '聯絡電話' })}</Text>
        <Text variant="body">{phone}</Text>
      </Box>
    </VStack>
  )
}
